import React from 'react';

const PlusIcon = ({size, thick}) => {
    const midPoint = size/2 - 1;
    const viewBox = "0 0 " + size + " " + size;
    const transform = "rotate(90 " + size + " " + midPoint + ")";
    return (
        <svg
            width={size}
            height={size}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x={midPoint} width={thick} height={size} fill="#1A1A1A" />
            <rect
            x={size}
            y={midPoint}
            width={thick}
            height={size}
            transform={transform}
            fill="#1A1A1A"
            />
      </svg>
    );
} 

export default PlusIcon;




// WEBPACK FOOTER //
// ./src/components/Icons/PlusIcon.js